import React from 'react';
import SlideServiceProduct from '@components/ServiceProduct/SlideServiceProduct';
import ServiceProductNav from '@components/ServiceProduct/ServiceProductNav';
import ListServiceProduct from '@components/ServiceProduct/ListServiceProduct';
import {NextSeo} from 'next-seo';
import AppConfigService from '@services/app-config.service';
import CategoryService from '@services/category.service';
import {getAutoSEO} from '@helper/seo/seo';

/**
 * Trang danh sách sản phẩm - dịch vụ
 * Clone từ trang chuyên khoa
 */
export default function ServiceProductHome(props) {
    const {seoPage} = props;
    
    return (
        <>
            {seoPage && <NextSeo {...seoPage} />}
            <SlideServiceProduct />
            <ServiceProductNav />
            <ListServiceProduct />
        </>
    );
}

ServiceProductHome.PageName = 'SERVICE_PRODUCT';

ServiceProductHome.getInitialProps = async (context) => {
    try {
        const ctx = context || {};
        const appConfigService = new AppConfigService(ctx);
        const seoConfig = await appConfigService.getAppConfig({page: 'SEO'});
        
        // Fetch data thực tế để tạo SEO tự động
        let pageData = {};
        try {
            const categoryService = new CategoryService(ctx);
            const productsResponse = await categoryService.getProductCategoryForWeb({
                locale: ctx.locale || 'vn'
            });
            const products = productsResponse?.data || productsResponse || [];
            pageData.totalProducts = Array.isArray(products) ? products.length : 0;
        } catch (err) {
            console.error('Failed to fetch products data for SEO:', err);
        }
        
        // Sử dụng getAutoSEO để tạo SEO tự động từ data
        let seoPage = getAutoSEO('SERVICE_PRODUCT', seoConfig, pageData);
        
        const webUrl = process.env.NEXT_PUBLIC_WEB_URL || 'https://tnh.com.vn';
        seoPage.canonical = `${webUrl}/san-pham-dich-vu`;
        if (seoPage.openGraph) {
            seoPage.openGraph.url = `${webUrl}/san-pham-dich-vu`;
        }
        
        return {seoPage};
    } catch (error) {
        console.error('Failed to fetch SEO for service product page:', error);
        return {seoPage: null};
    }
};


